<template>
  <div class="content">
    <section class="hero is-dark">
      <div class="columns">
        <search />
        <region />
        <state-selector @selectState="switchRegion" />
      </div>
    </section>
    <component
      :is="page"
      :state="state"
      @handleRegion="switchRegion"
    />
  </div>
</template>

<script>
  import UsMap from './UsMap.vue'
  import Search from './Search.vue'
  import Region from './Region.vue'
  import StateSelector from './StateSelector.vue'
  import SelectRegion from './SelectRegion.vue'
  export default {
    name: 'Location',
    metaInfo: {
      title: 'AHL Poker :: Location'
    },
    components: {
      UsMap,
      Search,
      Region,
      StateSelector,
      SelectRegion
    },
    props: ['user', 'token'],
    data () {
      return {
        page: 'us-map',
        state: ''
      }
    },
    mounted () {
      if (this.$route.params.state) {
        this.state = this.$route.params.state
        this.$router.push(`/location/${this.$route.params.state}`)
      }
    },
    methods: {
      switchRegion (state) {
        this.state = state
        this.$router.push(`/location/${state}`)
      }
    }
  }
</script>